<template>
  <HXContentCard title="Honorarios Éxito / Producción">
    <!-- Filtros -->
    <div class="row m-3">
      <div class="col-12 px-1 mt-3 d-flex justify-content-end">
        <vs-button
          success
          flat
          icon
          :to="{ name: 'AgregarArchivoCuentaCobro' }"
        >
          <i class="fas fa-upload mr-1"></i>
          Cargar soportes
        </vs-button>
      </div>
      <div class="col-4 col-lg-3 px-0">
        <h4 class="mb-2"><b>Mes:</b></h4>
        <b-select
          v-model="mesSeleccionado"
          class="form-control bg-dark personalizado"
          :options="listaMes"
          text-field="mes"
          value-field="id"
        />
      </div>
      <div class="col-4 col-lg-2 px-1">
        <h4 class="mb-2"><b>Año:</b></h4>
        <b-select
          v-model="anioSeleccionado"
          class="form-control bg-dark personalizado"
          :options="listaAnios"
        />
      </div>
      <div class="col col-lg-1 px-0 mt-3">
        <vs-button primary icon class="px-2" @click="filtrar" id="sendform2">
          <i class="fas fa-search"></i>
        </vs-button>
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-12 col-lg-6 mt-2" v-if="isAdmin">
            <h4 class="mb-2"><b>Filtrar x profesional:</b></h4>
            <v-select
              ref="selectProfesional"
              @input="obtenerDataProfesional()"
              class="style-chooser"
              :reduce="(value) => value"
              v-model="profesional"
              :options="listaProfesional"
              label="nombreProfesional"
              placeholder="-- selecciona un profesional --"
            >
              <div slot="no-options">No se encontraron resultados!</div>
            </v-select>
          </div>
          <div class="col-12 col-lg-6 mt-2" v-if="listaSucursal.length">
            <h4 class="mb-2"><b>Filtrar x sucursal:</b></h4>
            <v-select
              required
              ref="selectSucursal"
              class="style-chooser"
              :reduce="(value) => value"
              v-model="sucursal"
              :options="listaSucursal"
              label="sucursal"
              placeholder="-- selecciona opc. --"
              @input="filtrarDataPorSucursal()"
            >
              <div slot="no-options">No se encontraron resultados!</div>
            </v-select>
          </div>
        </div>
      </div>
    </div>

    <section class="p-4">
      <!-- TOTALES HONORARIOS -->
      <div class="d-flex mb-3 flex-wrap" style="gap: 1rem">
        <div
          v-for="item in totalesHonorarios"
          :key="item.id"
          class="py-2 px-4 bg-dark rounded"
        >
          <span>{{ item.label }}</span>
          <br />
          <h2 class="font-weight-bold text-white-50">
            {{
              item.value.toLocaleString("es-CO", {
                style: "currency",
                currency: "COP",
              })
            }}
          </h2>
        </div>
      </div>

      <div class="m-0" v-for="sect in sectionsList" :key="sect.id">
        <div
          class="d-flex align-items-center py-3 border-bottom"
          v-b-toggle="'collapse-h-' + sect.id"
        >
          <i
            :class="`fas fa-caret-${
              sect.collased ? 'down incline' : 'right'
            } text-primary mr-1 fa-lg`"
          ></i>
          <h3>
            <b>{{ sect.label }}</b>
          </h3>
        </div>

        <!-- COLLAPSE -->
        <b-collapse v-model="sect.collased" :id="'collapse-h-' + sect.id">
          <!-- HONORARIOS PRODUCCION -->
          <div v-if="sect.id == 1" class="m-0 m-lg-3">
            <vs-button
              v-if="profesional"
              class="mt-2"
              icon
              flat
              @click="verResumen()"
            >
              <i class="fas fa-file-lines mr-1"></i>
              Ver Resumen
            </vs-button>

            <section>
              <!-- tablas produccion -->
              <div v-for="item in tablesProduccion.tables" :key="item.id">
                <div class="m-3">
                  <h4>
                    <b>{{ item.id }}. {{ item.title }}</b>
                  </h4>
                </div>
                <vs-table striped>
                  <template #notFound>
                    <span>No se encontraron resultados</span>
                  </template>
                  <template #header>
                    <vs-input
                      v-model="item.search"
                      border
                      placeholder="Buscar..."
                    />
                  </template>
                  <template #thead>
                    <vs-tr>
                      <vs-th
                        v-for="(th, idx) in tablesProduccion.columns"
                        :key="idx"
                        sort
                        @click="item.data = $vs.sortData($event, item.data, th)"
                        >{{ th }}</vs-th
                      >
                    </vs-tr>
                  </template>
                  <template #tbody>
                    <vs-tr
                      v-for="row in $vs.getPage(
                        $vs.getSearch(item.data, item.search),
                        item.page,
                        max
                      )"
                      :data="row"
                      :key="row.id"
                    >
                      <vs-td>
                        {{ row.rut }}
                      </vs-td>
                      <vs-td>
                        {{ row.pacienteNombre }}
                      </vs-td>
                      <vs-td>
                        {{ row.concepto }}
                      </vs-td>
                      <vs-td>
                        {{ row.descripcion }}
                      </vs-td>
                      <vs-td>
                        {{ row.tipo }}
                      </vs-td>
                      <vs-td>
                        {{
                          row.valor.toLocaleString("es-CO", {
                            style: "currency",
                            currency: "COP",
                          })
                        }}
                      </vs-td>
                    </vs-tr>
                  </template>
                  <template v-if="item.data?.length > 0" #footer>
                    <vs-pagination
                      v-model="item.page"
                      :length="
                        $vs.getLength(
                          $vs.getSearch(item.data, item.search),
                          max
                        )
                      "
                    />
                  </template>
                </vs-table>
              </div>
            </section>
          </div>

          <!-- HONORARIOS EXITO -->
          <div v-else class="m-0 mt-lg-3">
            <vs-table v-if="honorariosExitoData.length > 0" striped>
              <template #thead>
                <vs-tr>
                  <vs-th
                    v-for="header in headersExito"
                    :key="header"
                    :colspan="encabezadosCombinados(header)"
                  >
                    {{ header }}
                  </vs-th>
                </vs-tr>
              </template>
              <template #tbody>
                <vs-tr
                  v-for="(row, index) in honorariosExitoData"
                  :data="row"
                  :key="index"
                >
                  <vs-td v-for="(cell, idx) in row" :key="idx">
                    {{ cell | formatValue(idx) }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>

            <not-found v-else />
          </div>
        </b-collapse>
      </div>
    </section>

    <!-- modal resumen -->
    <b-modal
      :title="'Resumen: ' + cadenaMes() + ' ' + anioSeleccionado"
      id="resumen"
      size="lg"
      hide-footer
    >
      <div class="p-2 mb-3 text-center">
        <h3>
          <b class="text-uppercase">
            {{ profesional?.nombreProfesional || "" }}
          </b>
        </h3>
      </div>

      <div class="row px-3">
        <div
          v-for="rsm in tablesResumen"
          :key="rsm.id"
          :class="`${rsm.id === 11 ? 'col-12' : 'col-12 col-lg-6'} px-1 mt-2`"
        >
          <div class="bg-dark p-2 font-weight-bold">
            {{ rsm.title }}
            {{ rsm.id === 8 ? `(${PorcentajeSucursal}%)` : "" }}
          </div>
          <h3 class="pl-2 my-2">
            <b>
              {{
                rsm.total.toLocaleString("es-CO", {
                  style: "currency",
                  currency: "COP",
                })
              }}</b
            >
          </h3>
        </div>
      </div>
    </b-modal>
  </HXContentCard>
</template>

<script>
import Swal from "sweetalert2";
import {
  tablesProduccion,
  tablesResumen,
  sectionsList,
  headersExito,
} from "./tablesSchema.js";

import { listaMes } from "@/config/constants.js";

export default {
  components: {
    notFound: () => import("@/components/helexium/notFound.vue"),
  },
  data() {
    return {
      max: 10,
      tablesProduccion: { ...tablesProduccion },
      tablesResumen: [...tablesResumen],
      sectionsList: [...sectionsList],
      headersExito: [...headersExito],
      listaMes: [...listaMes],
      honorariosExitoData: [],
      listaAnios: [],
      mesSeleccionado: null,
      anioSeleccionado: null,
      persona: {},
      listaPacientes: [],
      listaProfesional: [],
      listaSucursal: [],
      listaItems: [],
      listaItemsbk: [],
      profesional: null,
      sucursal: null,
      listaItemsMaterial: [],
      listaLaboratorio: [],
      listaLaboratorioBk: [],
      listaItemsRemision: [],
      listattos: [],
      Periodo: {},
      otrosConceptos: [],
      otrosConceptosBk: [],
      totalAgregados: 0,
      totalDescuentos: 0,
      totalTtosRealizados: 0,
      totalCostosMaterial: 0,
      totalCostosRemision: 0,
      totalCostosLaboratorio: 0,
      totalNetoHonorarios: 0,
      PorcentajeSucursal: 0,
      TotalHonorarios: 0,
      totalFinalNetoHonorarios: 0,
      totalDescuentosExcluidos: 0,
      totalAgregadosExcluidos: 0,
    };
  },
  async mounted() {
    this.getListaAnios();

    this.mesSeleccionado = new Date().getMonth();
    this.anioSeleccionado = new Date().getFullYear();

    this.persona = JSON.parse(localStorage.getItem("setPersonaAct"));
  },
  computed: {
    isAdmin() {
      return this.persona.rol.nivel >= 3;
    },
    totalesHonorarios() {
      const honorariosExitoTotal =
        this.honorariosExitoData.length > 0
          ? this.honorariosExitoData.reduce(
              (total, row) => total + row[row.length - 1],
              0
            )
          : 0;

      const totalHonorarios = this.totalFinalNetoHonorarios || 0;

      console.log("totalHonorarios", totalHonorarios);

      const totalGeneral = totalHonorarios + honorariosExitoTotal;

      return [
        { id: 1, label: "Honorarios de Producción", value: totalHonorarios },
        { id: 2, label: "Honorarios de Éxito", value: honorariosExitoTotal },
        { id: 3, label: "Total Honorarios", value: totalGeneral },
      ];
    },
  },
  methods: {
    actualizarTablas() {
      // Asigna los datos filtrados a cada tabla según el concepto
      this.tablesProduccion.tables[0].data = this.listaItems.filter(
        (item) =>
          item.concepto === "Ttos. realizados, cancelados y evolucionados"
      );
      this.tablesProduccion.tables[1].data = this.listaItems.filter(
        (item) => item.concepto === "Costos material especial"
      );
      this.tablesProduccion.tables[2].data = this.listaItems.filter(
        (item) => item.concepto === "Costos de remisión"
      );
      this.tablesProduccion.tables[3].data = this.listaItems.filter(
        (item) => item.concepto === "Costos Laboratorio"
      );
      // Si la tabla 5 es para "Otros conceptos", asigna la data correspondiente
      this.tablesProduccion.tables[4].data = this.otrosConceptos;

      // limpiar paginaciones
      this.tablesProduccion.tables.forEach((table) => {
        table.page = 1;
      });
    },

    async obtenerDataProfesional() {
      let mesSeleccionado = new Date(
        this.anioSeleccionado + "/" + this.mesSeleccionado + "/01"
      ).getMonth();
      let anioSeleccionado = this.anioSeleccionado; //new Date().getFullYear();
      this.Periodo = this.obtenerPrimerYUltimoDiaDelMes(
        anioSeleccionado,
        mesSeleccionado
      );
      console.log("periodo", this.Periodo);
      await this.obtenerData(this.Periodo.primerDia, this.Periodo.ultimoDia);
      // obtener otros conceptos
      await this.obtenerOtrosConceptos(
        this.Periodo.primerDia,
        this.Periodo.ultimoDia
      );
      this.PorcentajeSucursal = 0;
      console.log("profesional--->", this.profesional);
      let Persona = await this.$store.dispatch("hl_get", {
        path: "Persona/GetPersonaPorDocumento/" + this.profesional.rut,
      });
      console.log("persona0", Persona);

      let dataProfesional = await this.$store.dispatch("hl_get", {
        path:
          "FormalEducation/GetByPersonaId/" +
          Persona.id +
          "/" +
          Persona.empresaId,
      });
      console.log("persona-->", dataProfesional);
      if (dataProfesional.length > 0) {
        this.dataProfesional = dataProfesional[0].degree;
      }

      this.listaSucursal = this.listaItems.reduce((acc, obj) => {
        if (!acc.includes(obj.sucursal)) {
          acc.push(obj.sucursal);
        }
        return acc;
      }, []);

      console.log("this.listaSucursal", this.listaSucursal);
    },
    getListaAnios() {
      const anioActual = new Date().getFullYear();
      const anioInicio = anioActual - 2;
      const listaAnios = [];

      for (let anio = anioInicio; anio <= anioActual; anio++) {
        listaAnios.push(anio);
      }
      this.listaAnios = listaAnios;
    },
    async filtrarDataPorSucursal() {
      console.log("filtrando por sucursal", this.sucursal);

      if (!this.sucursal) return;
      this.listaItems = this.listaItemsbk.filter(
        (x) => x.sucursal == this.sucursal
      );
      this.otrosConceptos = this.otrosConceptosBk.filter(
        (x) => x.sucursal == this.sucursal
      );
      console.log("filtrando por sucursal", this.listaItems);
      console.log("filtrando por sucursal", this.otrosConceptos);
      await this.obtenerPorcentajeSucursal();

      console.log("this.listaItems ", this.listaItems);
      this.listattos = this.listaItems.filter(
        (x) => x.concepto == "Ttos. realizados, cancelados y evolucionados"
      );
      console.log("ttos ", this.listattos);
      this.listaItemsMaterial = this.listaItems.filter(
        (x) => x.concepto == "Costos material especial"
      );
      console.log("material ", this.listaItemsMaterial);
      this.listaItemsRemision = this.listaItems.filter(
        (x) => x.concepto == "Costos de remisión"
      );
      console.log("remision--> ", this.listaItemsRemision);

      this.listaLaboratorio = this.listaItems.filter(
        (x) => x.concepto == "Costos Laboratorio"
      );
      console.log("listaLaboratorio ", this.listaLaboratorio);

      // Actualiza las tablas con la data recién asignada
      this.actualizarTablas();

      await this.getHonorariosExitoTemp(
        this.anioSeleccionado,
        this.mesSeleccionado
      );

      await this.calculoTotalesv2();
    },
    async calculoTotalesv2() {
      try {
        //paso 1 calcular totales sin tomar en cuenta porcentaje y otros conceptos eso es al final
        console.log("totalttos-->", this.listattos);
        this.totalTtosRealizados = this.listattos.reduce(
          (accumulator, currentItem) => {
            const valueToAdd =
              Number(currentItem.valor) -
              Number(currentItem.valor) *
                parseFloat(currentItem.porcentajeLiquidacion);

            return accumulator + valueToAdd;
          },
          0
        );

        console.log("totalttos-->", this.totalTtosRealizados);
        this.totalCostosMaterial = this.listaItemsMaterial.reduce(
          (accumulator, currentItem) => {
            const valueToAdd = parseFloat(currentItem.valor);
            return accumulator + valueToAdd;
          },
          0
        );

        this.totalCostosRemision = this.listaItemsRemision.reduce(
          (accumulator, currentItem) => {
            const valueToAdd = parseFloat(currentItem.valor);
            return accumulator + valueToAdd;
          },
          0
        );

        this.totalCostosLaboratorio = this.listaLaboratorio.reduce(
          (accumulator, currentItem) => {
            const valueToAdd = parseFloat(currentItem.valor);
            return accumulator + valueToAdd;
          },
          0
        );

        this.totalNetoHonorarios =
          // Number(this.totalNetoHonorarios) +
          Number(this.totalTtosRealizados) -
          Number(this.totalCostosMaterial) -
          Number(this.totalCostosRemision) -
          Number(this.totalCostosLaboratorio);
        console.log("paso 1 ", this.totalNetoHonorarios.toFixed(2));
        // console.log('paso1 totalnet',this.totalNetoHonorarios)
        console.log("paso1 totalttosrealizados ", this.totalTtosRealizados);
        console.log("paso1 totalcostosmaterial ", this.totalCostosMaterial);
        console.log("paso1 totalcostosremision ", this.totalCostosRemision);
        console.log(
          "paso1 totalcostoslaboratorio ",
          this.totalCostosLaboratorio
        );
        //paso 2 calcular valores a excluir del porcentaje en otros conceptos
        let totalAgregadosExcluidos = 0;
        let listaAgregadosExcluidos = this.otrosConceptos.filter(
          (x) => x.tipo != "Descuento" && x.excluirPorcentaje
        );
        totalAgregadosExcluidos = listaAgregadosExcluidos.reduce(
          (accumulator, currentItem) => {
            const valueToAdd = parseFloat(currentItem.valor);
            return accumulator + valueToAdd;
          },
          0
        );
        let totalDescuentosExcluidos = 0;
        let listaDescuentosExcluidos = this.otrosConceptos.filter(
          (x) => x.tipo == "Descuento" && x.excluirPorcentaje
        );
        totalDescuentosExcluidos = listaDescuentosExcluidos.reduce(
          (accumulator, currentItem) => {
            const valueToAdd = parseFloat(currentItem.valor);
            return accumulator + valueToAdd;
          },
          0
        );

        this.totalDescuentosExcluidos = totalDescuentosExcluidos;
        this.totalAgregadosExcluidos = totalAgregadosExcluidos;

        console.log("paso2", listaAgregadosExcluidos);
        console.log("paso2", listaDescuentosExcluidos);
        console.log("paso2", totalAgregadosExcluidos);
        console.log("paso2", totalDescuentosExcluidos);
        //paso 3 totalizar valores del paso 1, aplicar descuentos o incrementos  a valores paso 1 para generar 1 solo total
        this.totalAgregados = 0;
        this.totalDescuentos = 0;
        let listaAgregados = this.otrosConceptos.filter(
          (x) => x.tipo != "Descuento" && x.excluirPorcentaje != true
        );
        let totalAgregados = listaAgregados.reduce(
          (accumulator, currentItem) => {
            const valueToAdd = parseFloat(currentItem.valor);
            return accumulator + valueToAdd;
          },
          0
        );
        let listaDescuentosttos = this.otrosConceptos.filter(
          (x) => x.tipo == "Descuento" && x.excluirPorcentaje != true
        );
        let totalDescuentosttos = listaDescuentosttos.reduce(
          (accumulator, currentItem) => {
            const valueToAdd = parseFloat(currentItem.valor);
            return accumulator + valueToAdd;
          },
          0
        );
        this.totalDescuentos = Number(totalDescuentosttos); //+ Number(totalDescuentos);
        this.totalAgregados = Number(totalAgregados); //+ Number(totalAgregados);
        this.totalNetoHonorarios =
          Number(this.totalNetoHonorarios) +
          Number(this.totalAgregados) -
          Number(this.totalDescuentos);
        console.log("paso3", listaAgregados);
        console.log("paso3", listaDescuentosttos);
        console.log("paso3", totalAgregados);
        console.log("paso3", totalDescuentosttos);

        //paso 4 aplicar porcentaje a total general
        this.TotalHonorarios =
          (this.totalNetoHonorarios * this.PorcentajeSucursal) / 100;
        console.log("paso 4", this.TotalHonorarios);
        //paso 5 aplicar descuentos o incrementos de valores excluidos porcentaje a total general
        this.totalFinalNetoHonorarios =
          Number(this.TotalHonorarios) +
          Number(this.totalAgregadosExcluidos) -
          Number(this.totalDescuentosExcluidos);
        //imprimiendo valores

        console.log("totalNetoHonorarios", this.totalFinalNetoHonorarios);

        // resumen
        this.tablesResumen[0].total = this.totalTtosRealizados;
        this.tablesResumen[1].total = this.totalCostosMaterial;
        this.tablesResumen[2].total = this.totalCostosRemision;
        this.tablesResumen[3].total = this.totalCostosLaboratorio;
        this.tablesResumen[4].total = this.totalAgregados;
        this.tablesResumen[5].total = this.totalDescuentos;
        this.tablesResumen[6].total = this.totalNetoHonorarios;
        this.tablesResumen[7].total = this.TotalHonorarios;
        this.tablesResumen[8].total = this.totalAgregadosExcluidos;
        this.tablesResumen[9].total = this.totalDescuentosExcluidos;
        this.tablesResumen[10].total = this.totalFinalNetoHonorarios;

        ///calculos totales///////////////////////////////////////////
      } catch (error) {
        console.log("error", error);
      }
    },
    async obtenerPorcentajeSucursal() {
      try {
        this.$isLoading(true);
        let res = await this.$store.dispatch("denti_get", {
          path:
            "Prestaciones/ObtenerFullPorcentajeSucursal/" +
            this.sucursal +
            "/" +
            this.dataProfesional,
        });
        this.PorcentajeSucursal = res;
        console.log("this.PorcentajeSucursal ", this.PorcentajeSucursal);
        //abr 19022024
        if (
          this.PorcentajeSucursal.excepcion
            .toUpperCase()
            .includes(this.profesional.nombreProfesional.toUpperCase())
        ) {
          this.PorcentajeSucursal =
            this.PorcentajeSucursal.excepcion.split("-")[1];
        } else {
          this.PorcentajeSucursal = this.PorcentajeSucursal.porcentaje;
        }
        console.log("this.PorcentajeSucursal2 ", this.PorcentajeSucursal);
        this.$isLoading(false);
      } catch (error) {
        this.$isLoading(false);
        this.PorcentajeSucursal = 0;
        console.log("this.PorcentajeSucursal3 error", error);
      }
    },
    async getHonorariosExitoTemp(anio = null, mes = null) {
      try {
        this.$isLoading(true);

        // Mejorar la legibilidad de la creación de path
        const path =
          anio && mes
            ? `HonorariosExitoTemp/Obtener/${anio}/${mes}`
            : "HonorariosExitoTemp/Obtener";
        let res = await this.$store.dispatch("denti_get", { path });

        console.log("res", res);

        const { success, data } = res;
        if (success && data !== null) {
          // Parsear los datos de Excel
          const parsedData = JSON.parse(data.data);

          console.log("parsedData", parsedData);

          const foundData = parsedData.excelData.filter(
            (row, idx) => row[1] == this.profesional.rut || idx === 0
          );

          console.log("foundData", foundData);

          this.honorariosExitoData = foundData;

          console.log("honorariosExitoData", this.honorariosExitoData);
        } else {
          console.log("No se encontraron datos");
          this.honorariosExitoData = [];
        }

        this.$isLoading(false);
      } catch (error) {
        console.error("Error al obtener los honorarios:", error);
        this.$isLoading(false);
        this.showToast("error", "Hubo un error al obtener los honorarios");
      }
    },
    encabezadosCombinados(header) {
      if (header == "CIERRES DE ORTODONCIA") return 9;
      if (header == "IMPLANTES MONTADOS") return 2;
      if (header == "MONTAJES DE ORTODONCIA") return 4;
      if (header == "PACIENTES QUE INICIAN") return 3;
    },
    cadenaMes() {
      let numero = this.mesSeleccionado;
      const meses = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];

      // Verificar que el número esté en el rango válido (1-12)
      if (numero < 1 || numero > 12) {
        return "Número inválido. Debe estar entre 1 y 12.";
      }

      // Restar 1 para obtener el índice correcto del mes
      return meses[numero - 1];
    },
    verResumen() {
      this.$bvModal.show("resumen");
    },
    showToast(type, message) {
      console.log(type);
      if (type == "success") {
        this.$toast.success(message, {
          position: "top-center",
          timeout: 1492,
          closeOnClick: true,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          draggable: false,
          draggablePercent: 0.41,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false,
        });
      }
      if (type == "error")
        this.$toast.error(message, {
          position: "top-center",
          timeout: 1492,
          closeOnClick: true,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          draggable: false,
          draggablePercent: 0.41,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false,
        });
      if (type == "warning")
        this.$toast.warning(message, {
          position: "top-center",
          timeout: 1492,
          closeOnClick: true,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          draggable: false,
          draggablePercent: 0.41,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false,
        });
    },

    async filtrar() {
      this.profesional = null;
      this.sucursal = null;
      ////////
      this.$isLoading(true);
      //filtrar x mes y año
      let mesSeleccionado = new Date(
        this.anioSeleccionado + "/" + this.mesSeleccionado + "/01"
      ).getMonth();
      let anioSeleccionado = this.anioSeleccionado; //new Date().getFullYear();
      this.Periodo = this.obtenerPrimerYUltimoDiaDelMes(
        anioSeleccionado,
        mesSeleccionado
      );
      await this.getData(this.Periodo.primerDia, this.Periodo.ultimoDia);

      //  obtener data del profesional activo
      if (!this.isAdmin) await this.obtenerDataProfesional();

      this.$isLoading(false);
    },
    async obtenerData(primerDia, ultimoDia) {
      console.log("proff", this.profesional);
      this.listaItems = [];
      let res = await this.$store.dispatch("denti_get", {
        path:
          "Prestaciones/MiHonorarioPorProfesionalFecha/" +
          this.profesional.nombreProfesional +
          "/" +
          primerDia +
          "/" +
          ultimoDia,
      });
      console.log("otros", res);
      this.listaItems = res;
      this.listaItemsbk = res;
    },
    async obtenerOtrosConceptos(primerDia, ultimoDia) {
      this.otrosConceptos = [];
      let res = await this.$store.dispatch("denti_get", {
        path:
          "Prestaciones/ListaOtrosConceptosPorProfesional/" +
          primerDia +
          "/" +
          ultimoDia +
          "/" +
          this.profesional.nombreProfesional +
          "/",
      });
      console.log("otros", res);
      // this.otrosConceptos = res;
      this.otrosConceptosBk = res;
    },

    obtenerPrimerYUltimoDiaDelMes(anio, mes) {
      // El mes en JavaScript es base 0, por lo que enero es 0 y diciembre es 11
      const primerDia = new Date(anio, mes, 1);
      const ultimoDia = new Date(anio, mes + 1, 0); // El día 0 del mes siguiente es el último día del mes actual

      return {
        primerDia: primerDia.toISOString().split("T")[0], // Formato YYYY-MM-DD
        ultimoDia: ultimoDia.toISOString().split("T")[0],
      };
    },
    async getData(primerDia, ultimoDia) {
      try {
        this.listaItems = [];
        // console.log("getdata dentisalud", Periodo);

        const url = this.isAdmin
          ? `Prestaciones/ListaProfesionalesPorPeriodo/${primerDia}/${ultimoDia}`
          : `Prestaciones/GetProfesionalPorPeriodo/${primerDia}/${ultimoDia}/${this.persona.numeroDocumento}`;

        let res = await this.$store.dispatch("denti_get", {
          path: url,
        });
        console.log("res dentisalud ", res);

        let uniqueProfesionales = new Set();

        if (this.isAdmin) {
          this.listaProfesional = res.map((x) => {
            console.log("x-->0", x);
            let nombreProfesional = x.profesional.nombreProfesional;
            // Verificar si el nombreProfesional es único
            if (
              nombreProfesional &&
              !uniqueProfesionales.has(nombreProfesional)
            ) {
              uniqueProfesionales.add(nombreProfesional);
              return {
                nombreProfesional: nombreProfesional,
                rut: x.profesional.rut,
              };
            }

            return null; // Ignorar duplicados
          });
          console.log("lista profesionales", this.listaProfesional);
        } else {
          if (!res.data) {
            Swal.fire({
              icon: "info",
              title: "Sin resultados",
              text: "No se encontraron prestaciones.",
            });
            this.$isLoading(false);
            return;
          }
          this.profesional = res.data.profesional;
        }

        this.$isLoading(false);
      } catch (error) {
        this.$isLoading(false);

        this.listaItems = [];
        console.log("err dentisalud ", error);
      }
    },
  },
  filters: {
    formatValue(value, idx) {
      console.log("value", value);

      if (value === undefined || value === null) return "";

      const formatters = {
        currency: [
          6, 7, 10, 11, 12, 13, 14, 15, 16, 21, 25, 27, 31, 34, 35, 37, 40,
        ],
        date: [3],
        percentage: [8, 9, 20, 30],
        numberWithCommas: [4, 19, 29, 33],
      };

      if (typeof value === "number") {
        if (formatters.currency.includes(idx)) {
          // Formatear como moneda
          return new Intl.NumberFormat("es-CO", {
            style: "currency",
            currency: "COP",
            maximumFractionDigits: 0,
          }).format(value);
        } else if (formatters.date.includes(idx)) {
          // Formatear como fecha (en caso de que sea un valor numérico de fecha de Excel)
          const excelEpoch = new Date(1899, 11, 30); // La fecha base de Excel es el 30 de diciembre de 1899
          const date = new Date(excelEpoch.getTime() + value * 86400000); // Convertir a milisegundos
          return date.toLocaleDateString("es-CO"); // Formatear la fecha en el formato deseado
        } else if (formatters.percentage.includes(idx)) {
          // Formatear como porcentaje
          return (value * 100).toFixed(1) + "%";
        } else if (formatters.numberWithCommas.includes(idx)) {
          // Redondear a un decimal y luego formatear con separadores de miles
          return new Intl.NumberFormat("es-CO").format(
            Math.round(value * 10) / 10
          );
        }
      }

      return value;
    },
  },
};
</script>
